import AccountPending from "@/components/landing/auth/AccountPending";

export default function AccountPendingPage() {
  return <AccountPending />;
}
